import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
import QueryParams from '@/utilities/gridManager/QueryParams'
// eslint-disable-next-line prettier/prettier
import type { SitePayloadType } from '@/api/types/request/SitePayloadType'
import type { CreateSiteType, DeleteSiteType, SiteListType, ResetArmsAndAnalysisType } from '@/api/types/response/SiteType'
import type { SiteListPayloadType } from '@/api/types/request/SiteListPayloadType'

/**
 * @property string apiEnd /api/sales/bid/spec/{bidNumber}
 */
export default class SitesApi extends AbstractApi {
  fetchAll(payload: SiteListPayloadType): Promise<SiteListType> {
    return httpClient.get(`${this.apiEnd}/sites?${new QueryParams<SiteListPayloadType>(payload).toString()}`)
  }

  add(payload: SitePayloadType): Promise<CreateSiteType> {
    return httpClient.post(this.apiEnd, payload)
  }

  update(id: number, payload: SitePayloadType): Promise<CreateSiteType> {
    return httpClient.put(`${this.apiEnd}/${id}`, payload)
  }

  delete(id: number): Promise<DeleteSiteType> {
    return httpClient.delete(`${this.apiEnd}/${id}`)
  }

  resetArmsAndAnalysis(siteId: number): Promise<ResetArmsAndAnalysisType> {
    return httpClient.delete(`${this.apiEnd}/site/${siteId}/reset/arms/analysis`)
  }
}
